
<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="6" :sm="24">
            <a-form-item label="关键字">
              <a-input v-model="queryParam.keywords" allowClear  placeholder="搜索关键字"/>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="赛季">
              <a-select v-model="queryParam.saiji" placeholder="请选择"
                        allowClear >
                <a-select-option v-for="(option,index) in saijiOptions" :value="option.id">{{option.name}}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <template v-if="advanced">
            <a-col :md="6" :sm="24">
              <a-form-item label="授权编号">
                <a-input v-model="queryParam.kaojiregist_code" placeholder="搜索授权编号"/>
              </a-form-item>
            </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="单位名称">
              <a-input v-model="queryParam.danwei" placeholder="搜索单位名称"/>
            </a-form-item>
          </a-col>



           </template>
          <a-col :md="!advanced && 6 || 24" :sm="24">
            <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
              <a-button type="primary" @click="onSearch">查询</a-button>
              <a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button>
              <a @click="toggleAdvanced" style="margin-left: 8px" v-if="false">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'" />
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <div class="table-operator" >
      <!--<a-button type="primary" icon="plus" @click="addHandle" >新建</a-button>-->
      <a-button type="primary" icon="plus"   @click="addHandle" >申请办赛</a-button>
    </div>

    <s-table
      ref="table"
      size="default"
      :columns="columns"
      :data="loadData"
      :alert="{ show: true, clear: () => { this.selectedRowKeys = [] } }"
      :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
    >

      <span slot="name" slot-scope="text,record">
          <div style="margin-left: 10px; float: left">
            申请人{{record.name}} {{record.phone}}
            <br/><span style="color: #999">{{record.province}}{{record.city}}{{record.county}}</span>
            <br/>
            申请时间 {{record.create_time|timeFormat}}
            <br/>
            比赛时间 {{record.time_start}} - {{record.time_end}}
          </div>
      </span>
      <span slot="status" slot-scope="text,record">


        <a-tag v-if="record.status==2" color="green">审核通过</a-tag>
        <a-tag v-else-if="record.status==3" color="red">审核失败</a-tag>
        <a-tag v-else>待审核</a-tag>
        <br/>
<!--        <a-tag  v-if="record.status==2">审核通过,请进行项目配置</a-tag>-->

      </span>
      <span slot="action" slot-scope="text,record">
        <template >
          <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical" />
          <a @click="handleDocument(record)" >协议管理</a>
          <a-divider type="vertical" />

            <a-popconfirm
                    v-show="record.status==3||record.status==1"
                    title="确定删除吗"
                    @confirm="onDelete(record,index)"
                    okText="确定"
                    cancelText="取消"
            >
              <a href="javascript:;">删除</a>
            </a-popconfirm>
        </template>
      </span>
    </s-table>

    <a-modal
            title="申请办赛"
            :width="1200"
            :bodyStyle="{maxHeight:'500px','overflowY':'scroll'}"
            v-model="visible"
            @ok="handleOk"
    >
      <a-spin :spinning="saveLoading">
        <a-form :form="form" >
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="办赛模式"
                      hasFeedback
              >
                <a-select v-model="formData.mode"  placeholder="请选择"
                          allowClear >
                  <a-select-option v-for="(option,index) in [{'name':'全额办赛','id':1},{'name':'差额办赛','id':2},{'name':'自主办赛',id:3}]" :value="option.name">{{option.name}}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="赛事类型"
                      hasFeedback
              >
                <a-radio-group v-model="formData.is_online" button-style="solid">
                  <a-radio-button :value="1">
                    线上
                  </a-radio-button>
                  <a-radio-button :value="2">
                    线下
                  </a-radio-button>
                </a-radio-group>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="申请人"
                      hasFeedback
              >
                <a-input   v-decorator="[
              'name',
              {rules: [{ required: true, message: '请输入申请人' }]}
            ]"
                         placeholder="请输入申请人"/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="联系电话"
                      hasFeedback
              >
                <a-input    v-decorator="[
              'phone',
              {rules: [{ required: true, message: '请输入联系电话' }]}
            ]"
                         placeholder="请输入联系电话"/>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="申请单位"
                      hasFeedback
              >
                <a-input   v-decorator="[
              'danwei',
              {rules: [{ required: true, message: '请输入申请单位' }]}
            ]"
                         placeholder="请输入申请单位"/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
              v-if='false'
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="微信号"
                      hasFeedback
              >
                <a-input    v-decorator="[
              'weixin',
              {rules: [{ required: true, message: '请输入微信号' }]}
            ]"
                         placeholder="请输入微信号"/>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="所在地区"
                      hasFeedback
              >
                <a-cascader :options="areaOptions"  @change="areaChange"  placeholder="请选择地区" v-model="formData.areas" changeOnSelect />
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="场馆名称"
                      hasFeedback
              >
                <a-input    v-decorator="[
              'changguan',
              {rules: [{ required: true, message: '请输入场馆名称' }]}
            ]"
                            placeholder="请输入场馆名称"/>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="场馆地址"
                      hasFeedback
              >
                <a-input    v-decorator="[
              'address',
              {rules: [{ required: true, message: '请输入场馆地址' }]}
            ]"
                            placeholder="请输入场馆地址"/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                                    :extra="saiName"
                      label="申请赛事类型"
                      hasFeedback
              >
                <a-select v-model="formData.type_name"   @change="typeChange" placeholder="请选择"
                          allowClear >
                  <a-select-option v-for="(option,index) in [{'name':'全国啦啦操联赛分站赛','id':1},{'name':'少儿精英赛','id':2},{'name':'城市挑战赛',id:3}]" :value="option.name">{{option.name}}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>


          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="拟定赛事时间"
                      extra="赛前45天申请"
                      hasFeedback
              >
                <a-range-picker
                        v-model="formData.time_range_moment"
                                        @change="dateChange"
                        :showTime="{
      }"
                        format="YYYY-MM-DD"
                />
              </a-form-item>
            </a-col>

              <a-col :md="12" :sm="24">
                <a-form-item
                        :labelCol="labelCol"
                        :wrapperCol="wrapperCol"
                        label="保底人数"
                        hasFeedback
                >
                  <a-input    v-decorator="[
              'member',
              {rules: [{ required: true, message: '请输入保底人数' }]}
            ]"
                              placeholder="请输入保底人数"/>
                </a-form-item>
            </a-col>
          </a-row>


          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="主办"
                      hasFeedback
              >
                <a-textarea
                        v-model="formData.zban"
                        placeholder="主办单位"
                        :auto-size="{ minRows: 3, maxRows: 5 }"
                />
              </a-form-item>
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="承办"
                      hasFeedback
              >
                <a-textarea
                    v-model="formData.cban"
                    placeholder="承办单位"
                    :auto-size="{ minRows: 3, maxRows: 5 }"
                />
              </a-form-item>
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="协办"
                      hasFeedback
              >
                <a-textarea
                    v-model="formData.xban"
                    placeholder="协办单位"
                    :auto-size="{ minRows: 3, maxRows: 5 }"
                />
              </a-form-item>

            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="赛事经费来源及金额"
                      hasFeedback
              >
                <p>政府购买服务 <a-input  style="width:100px" v-model="formData.jf1"
                                     placeholder=""/>元</p>
                <p>商业赞助 <a-input   style="width:100px"  v-model="formData.jf2"
                                     placeholder=""/>元</p>
                <p>其他 <a-input   style="width:100px"  v-model="formData.jf3"
                                     placeholder=""/>元</p>
              </a-form-item>
            </a-col>
          </a-row>


          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="其他办赛资源"
                      hasFeedback
              >

                <a-textarea
                        v-model="formData.ziyuan"
                        placeholder="如：政府支持，体育局、教育局支持、安保、医疗设施完善、往站办赛经验"
                        :auto-size="{ minRows: 3, maxRows: 5 }"
                />              </a-form-item>
            </a-col>

          </a-row>


          <a-divider>承办方信息</a-divider>

          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="赛事负责姓名"
                      hasFeedback
              >
                <a-input  v-decorator="[
              'sai_name',
              {rules: [{ required: true, message: '请输入赛事负责姓名' }]}
            ]"
                          placeholder="请输入赛事负责姓名"/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="赛事负责电话"
                      hasFeedback
              >
                <a-input  v-decorator="[
              'sai_phone',
              {rules: [{ required: true, message: '请输入赛事负责电话' }]}
            ]"
                          placeholder="请输入赛事负责电话"/>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="赛事咨询姓名1"
                      hasFeedback
              >
                <a-input  v-decorator="[
              'sai_name1',
              {rules: [{ required: true, message: '请输入赛事咨询姓名1' }]}
            ]"
                          placeholder="请输入赛事咨询姓名1"/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="赛事咨询电话"
                      hasFeedback
              >
                <a-input  v-decorator="[
              'sai_phone1',
              {rules: [{ required: true, message: '请输入赛事咨询电话' }]}
            ]"
                          placeholder="请输入赛事咨询电话"/>
              </a-form-item>
            </a-col>
          </a-row>

          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="赛事咨询姓名2"
                      hasFeedback
              >
                <a-input
                        v-model="formData.sai_name2"
                          placeholder="请输入赛事咨询姓名1"/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="赛事咨询电话"
                      hasFeedback
              >
                <a-input
                        v-model="formData.sai_phone2"
                          placeholder="请输入赛事咨询电话"/>
              </a-form-item>
            </a-col>
          </a-row>

        </a-form>

      </a-spin>
      <template slot="footer">
        <a-button key="cancel" @click="visible=false">取消</a-button>
        <a-button key="forward" :loading="saveLoading" :disabled="formData.status==2" type="primary" @click="handleOk">提交</a-button>
      </template>
    </a-modal>


    <a-modal
            title="相关协议操作"
            :width="1000"
            style="top: 20px;"
            :bodyStyle="{maxHeight:'500px','overflowY':'scroll'}"
            v-model="xieyiVisible"
            @ok="xieyiVisible=false"
    >
      <a-spin :spinning="saveLoading">
        <a-form :form="form">

          <a-table :columns="documentColumns" :dataSource="documentList" :pagination="false" rowKey="id" :scroll="{ y: 300 }" bordered>
            <div slot="file" slot-scope="name,record">
              <p v-for="(file,findex) in record.files" :key="findex">
                <a  @click="downloadXieyi(file)">{{file.name}}</a>

              </p>
              <em v-if="record.note" >({{record.note}})</em>
            </div>
            <template slot="user_name" slot-scope="text,record,index">
              <a-tag v-if="record.user_type==2" color="red">
                CCA
              </a-tag>
              <a-tag v-else color="blue">
                省市
              </a-tag>
              {{record.user_name}}
            </template>

            <template slot="footer" slot-scope="currentPageData">

              <file-uploader
                      style="width: 200px; margin-right: 10px; float: left"
                      :file-list="fileFormData.files"
                      :numberLimit="5"
              />
              <a-input
                      style="width: 200px; margin-right: 10px; float: left"
                      v-model="fileFormData.note"
                      placeholder="请输入备注信息"/>
              <a-button icon="plus" @click="addFile" >新增</a-button>
            </template>
          </a-table>
        </a-form>
      </a-spin>
    </a-modal>
  </a-card>
  </template>

  <script>
  import STable from '@/components/table/'
  import ATextarea from 'ant-design-vue/es/input/TextArea'
  import AInput from 'ant-design-vue/es/input/Input'
  import EditableCell from '@/components/EditableCell/'
  import PicUploader from '@/components/PicUploader/'
  import FileUploader from '@/components/FileUploader/'
    import {getCityName} from '@/api/utils'
  import RSwitch from '@/components/RSwitch/'
  import areaOptions from '@/utils/area'
  import setting from '@/config/setting'
  import moment from 'moment'
  import 'moment/locale/zh-cn';
  moment.locale('zh-cn');

  import { getSaiquApplyList ,getSaiquApplyDetail,editSaiquApply,addSaiquApply,getSaijiList ,getSubjectTypeOptions,addXieyiFile,getXieyiList,saiquApplyDelete } from '@/api/sai'
  export default {
    name: 'SaiquApplyList',
    components: {
      AInput,
      ATextarea,
      FileUploader,
      PicUploader,
      STable,
      RSwitch,
      EditableCell,
    },
    data () {
      return {
        areaOptions,
        visible: false,
        xieyiVisible: false,
        saveLoading:false,
                subjectTypeOptions:[],
        formData:{
          id:0,
          status:1,
          is_online:2,
          zban:'国家体育总局体操运动管理中心\n中国蹦床与技巧协会\n',
          cban:'中国蹦床与技巧协会啦啦操分会\n南京新恒鼎体育推广有限公司\n',
          xban:'南京合生汇信息科技有限公司\n',
          photo_service:1,
          type:1,
          danwei:'',
          saidate_moment:[],
          saidate:[],
          time_range_moment:[],
          time_range:[],
          erweiimg:[],
          areas:[],
          pic:[],
          pics:[],
        },
        saijiOptions:[],
        labelCol: {
//          xs: { span: 24 },
//          sm: { span: 5 },
          xs: { span: 24 },
          sm: { span: 8 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 12 },
        },
        form: this.$form.createForm(this),
        mdl: {},

        // 高级搜索 展开/关闭
        advanced: false,
        // 查询参数
        queryParam: {
          keywords:'',
        },
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: 'id',
            width: '50px'
          },
          {
            title: '名称',
            dataIndex: 'name',
            scopedSlots: { customRender: 'name' },
          },
          {
            title: '状态',
            dataIndex: 'status',
            scopedSlots: { customRender: 'status' },
          },
          {
            title: '操作',
            dataIndex: 'action',
            fixed: 'right',
            width: 200,
            scopedSlots: { customRender: 'action' },
          }
        ],
        // 加载数据方法 必须为 Promise 对象
        loadData: parameter => {
          console.log('loadData');
          console.log(this.queryParam);
          let that= this;


          this.queryParam = Object.assign(this.queryParam,parameter);
          return getSaiquApplyList(this.queryParam)
            .then(res => {
              console.log('res');
              return res.data
            })
        },

        selectedRowKeys: [],
        selectedRows: [],
        cashFormData:{
          ids:[],
          to_type:'',
          price:0,
          note:'',
          count:0,
        },

        fileFormData:{
          apply_id:undefined,
          note:undefined,
          files: []
        },
        //人员管理表头
        documentColumns: [
          {
            title: '#',
            dataIndex: 'id',
            width: '50px'
          },
          {
            title: '文件',
            dataIndex: 'title',
            scopedSlots: { customRender: 'file' },
          },
          {
            title: '上传人',
            dataIndex: 'user_name',
            width:'150px',
            scopedSlots: { customRender: 'user_name' },
          },
           {
           title: '上传时间',
           width:'150px',
             dataIndex: 'create_time',
             customRender: (text) =>  {
               return moment(text*1000).format('YYYY-MM-DD HH:mm');
             }
           },
        ],
        documentList:[],
        documentKeywords: '',
                locationName:'',
                saiName:''
      }
    },
    computed:{
    },
    created(){
    },

    mounted(){
      let that = this;
      that.getSaijiOptions();
    },
    methods: {
      moment,

      getSaijiOptions(){
        let that = this;
        getSaijiList().then(res =>{
          that.saijiOptions = res.data.list
        })
      },
      addHandle(){
                   this. saiName = '';
        this.formData = {
          id:0,
          status:1,
          is_online:2,
          zban:'国家体育总局体操运动管理中心\n中国蹦床与技巧协会\n',
          cban:'中国蹦床与技巧协会啦啦操分会\n南京新恒鼎体育推广有限公司\n',
          xban:'南京合生汇信息科技有限公司\n',
          photo_service:1,
          type:1,
          danwei:'',
          saidate_moment:[],
          saidate:[],
          time_range_moment:[],
          time_range:[],
          erweiimg:[],
          areas:[],
          pic:[],
          pics:[], 
        },
        this.form.resetFields();
        this.visible = true
      },
      handleCancel(){
        this.visible = false
      },
      //展开关闭
      toggleAdvanced() {
        this.advanced = !this.advanced
      },
      handleEdit(record){
        let self = this
        this.visible = true
        getSaiquApplyDetail({ id: record.id }).then(res => {
          setTimeout(() =>{
            self.form.setFieldsValue({ ...res.data })
            self.formData.id = record.id;
            console.log('handleEdit')
            if(res.data.area){
              res.data.areas = [res.data.area.substring(0,2)+'0000',res.data.area.substring(0,4)+'00',res.data.area];
            }else{
              res.data.areas = [];
            }
            res.data.time_range_moment = [moment(res.data.time_start,'YYYY-MM-DD'),moment(res.data.time_end,'YYYY-MM-DD')];
            self.formData = { ...res.data };

                self.freshSaiName();
          },200)
        })
        // console.log(this.mdl)
      },
    // 查
    onSearch() {
      let self = this;
      self.$refs.table.refresh(false)
    },

      // 增改 处理
      handleOk(e) {
        let self = this;
        e.preventDefault()
        if(self.formData.time_range_moment.length!=2){
          self.$message.error('请选择时间范围');
          return ;
        }
        if(!self.formData.type_name){
          self.$message.error('请选择赛事类型');
          return ;
        }
        if(!self.formData.mode){
          self.$message.error('请选择赛事模式');
          return ;
        }
        if(self.formData.areas.length!=3){
          self.$message.error('请选择完整地区');
          return ;
        }
        this.form.validateFields((err, values) => {
          if (!err) {
            console.log('Received values of form: ', values)
            console.log('Received valuess of formData: ', self.formData)
            self.saveLoading = true;
            if(self.formData.id>0){

                editSaiquApply({
                  id:self.formData.id,
                  name:values.name,
                  phone:values.phone,
                  danwei:values.danwei,
                  weixin:values.weixin,
                  area:self.formData.areas[self.formData.areas.length-1],
                  changguan:values.changguan,
                  address:values.address,
                  type_name:self.formData.type_name,
                  member:values.member,
                  status:self.formData.status,
                  mode:self.formData.mode,
                  is_online:self.formData.is_online,
                  xban:self.formData.xban,
                  cban:self.formData.cban,
                  zban:self.formData.zban,
                  ziyuan:self.formData.ziyuan,
                  time_range:[self.formData.time_range_moment[0].format('YYYY-MM-DD'),self.formData.time_range_moment[1].format('YYYY-MM-DD')],
                  jf1:self.formData.jf1,
                  jf2:self.formData.jf2,
                  jf3:self.formData.jf3,
                  sai_name:values.sai_name,
                  sai_phone:values.sai_phone,
                  sai_name1:values.sai_name1,
                  sai_phone1:values.sai_phone1,
                  sai_name2:self.formData.sai_name2,
                  sai_phone2:self.formData.sai_phone2,
                  admin_note:self.formData.admin_note,
                }).then(res => {
                  self.$message.success('修改成功')
                  self.$refs.table.refresh(false)
                  self.visible = false;
                  self.saveLoading = false;
              }).catch(err =>{
                  self.$message.error(err.data.msg);
                  self.saveLoading = false;
              })
            }else{
                addSaiquApply({
                  name:values.name,
                  phone:values.phone,
                  danwei:values.danwei,
                  weixin:values.weixin,
                  area:self.formData.areas[self.formData.areas.length-1],
                  changguan:values.changguan,
                  address:values.address,
                  type_name:self.formData.type_name,
                  member:values.member,
                  status:self.formData.status,
                  mode:self.formData.mode,
                  is_online:self.formData.is_online,
                  xban:self.formData.xban,
                  cban:self.formData.cban,
                  zban:self.formData.zban,
                  jf1:self.formData.jf1,
                  jf2:self.formData.jf2,
                  jf3:self.formData.jf3,
                  ziyuan:self.formData.ziyuan,
                  time_range:[self.formData.time_range_moment[0].format('YYYY-MM-DD HH:mm:ss'),self.formData.time_range_moment[1].format('YYYY-MM-DD HH:mm:ss')],

                  sai_name:values.sai_name,
                  sai_phone:values.sai_phone,
                  sai_name1:values.sai_name1,
                  sai_phone1:values.sai_phone1,
                  sai_name2:values.sai_name2,
                  sai_phone2:values.sai_phone2,
                }).then(res => {
                  self.$message.success('修改成功')
                self.$refs.table.refresh(false)
                self.visible = false;
                self.saveLoading = false;
              }).catch(err =>{
                  self.$message.error(err.data.msg);
                self.saveLoading = false;
              })
            }

          }
        })
      },


      handleDocument(record) {
        let self = this
        self.fileFormData.apply_id = record.id;
        self.getDocumentList();

        this.xieyiVisible = true
      },

      getDocumentList(){
        let self = this
        getXieyiList({apply_id: self.fileFormData.apply_id}).then(res => {
          self.documentList = res.data
        })
      },
      onDelete(record){
        let self = this;
        saiquApplyDelete({
          id:record.id
        }).then(res => {
          self.$refs.table.refresh()
        }).catch(err =>{
          self.$message.error(err.data.msg);
        })

      },
      addFile(){
        let self = this;
        if(self.fileFormData.files.length==0){
          self.$message.error('请上传文件');
          return ;
        }
        addXieyiFile(self.fileFormData).then(res => {
          self.getDocumentList();
          self.fileFormData.files = [];
          self.$message.success('新增成功')
        }).catch(err =>{
          self.$message.error(err.data.msg);
        })
      },
      downloadXieyi(file){
        let self = this;
        window.open(setting.apiBaseURL+'/api/index/dlf?name='+file.name+'&url='+encodeURIComponent(file.url));
      },
    onSelectChange (selectedRowKeys, selectedRows) {
        this.selectedRowKeys = selectedRowKeys
        this.selectedRows = selectedRows
      },
            typeChange(){
                this.freshSaiName();
            },
            areaChange(val,val2){
                this.freshSaiName();
                console.log(val,val2);
            }, 
            dateChange(val,val2){
                this.freshSaiName();
                console.log(val,val2);
            },
            freshSaiName(){ 
                let self = this;
                if(this.formData.time_range_moment.length==0){
                    return '';
                }
                getCityName({
                    area:self.formData.areas[self.formData.areas.length-1],
                }).then(res => {
                    self.locationName = res.data; 
                    let year = self.formData.time_range_moment[0].format('YYYY');
                    let month = self.formData.time_range_moment[0].format('M');
                    let yearName = '';
                    if(month >= 8){
                         yearName = year+'-'+(parseInt(year)+1)
                    }else{
                         yearName = (year-1)+'-'+(year)
                    }
                    let type_name = '';
                    switch(self.formData.type_name){
                        case '全国啦啦操联赛分站赛':
                            type_name = '全国啦啦操联赛';break;

                        case '少儿精英赛':
                            type_name = '全国少儿啦啦操精英赛';break;

                        case '俱乐部联赛分站赛': case '城市挑战赛':
                            type_name = '全国啦啦操俱乐部联赛';break;

                        case '青少年精英赛':
                            type_name = '全国青少年啦啦操精英赛';break;
                    }
 
                    self.saiName =  yearName+'年'+type_name+'('+self.locationName+'站)'  
                }).catch(err =>{ 
                }) 
            }

    },
    filters:{
    },
    watch: {
    }
  }
</script>
